module.exports = __webpack_public_path__ + "static/randolph-melville.c4ccf5cb.webp";